import {
  SmartPairedBayBlock,
  SmartUnpairedBayBlock,
  TIContainerInformationExtendedValid,
} from "@tedivo/tedivo-bay-grid-pure";

import { BayLevelEnum } from "open-vessel-definition";
import { TGetContainersFilterOutput } from "./TGetContainersFilterOutput";
import { topContainersOfStack } from "./topContainersOfStack";

/**
 * The highest container of every stack above deck, and nothing from the hold:
 * the mirror of getContainersByHighestBelow. A stack with hold cargo but an
 * empty deck draws nothing.
 */
export function getContainersByHighestAbove(
  smartBay: SmartUnpairedBayBlock | SmartPairedBayBlock,
): TGetContainersFilterOutput {
  const containers: TIContainerInformationExtendedValid[] = [];

  // Only process above deck containers
  if (smartBay.level !== BayLevelEnum.ABOVE) {
    return {
      containers,
      tBaysStr: smartBay.tBaysStr,
      level: smartBay.level,
    };
  }

  const { gridContent, allStacksKeys, allTiersKeys } = smartBay.getGridContent();

  // For each stack, get the highest container above deck
  for (const stackKey of allStacksKeys) {
    containers.push(
      ...topContainersOfStack(smartBay, gridContent, stackKey, allTiersKeys, "highest"),
    );
  }

  return {
    containers,
    tBaysStr: smartBay.tBaysStr,
    level: smartBay.level,
  };
}
